// VendorProfile.js
import React, { useMemo } from "react";

const safe = (v) => (v === null || v === undefined || String(v).trim() === "" ? "—" : v);

const initials = (name = "") => {
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  const a = parts[0]?.[0] || "";
  const b = parts[1]?.[0] || "";
  return (a + b).toUpperCase() || "VN";
};

const InfoCell = ({ icon, label, value }) => (
  <div className="yx-vpCell">
    <div className="yx-vpCell__icon">
      <i className={`fa ${icon}`} />
    </div>
    <div className="yx-vpCell__text">
      <div className="yx-vpCell__label">{label}</div>
      <div className="yx-vpCell__value" title={safe(value)}>
        {safe(value)}
      </div>
    </div>
  </div>
);

const VendorProfile = ({ vendorData }) => {
  const data = useMemo(() => vendorData || {}, [vendorData]);

  const title = safe(data.title);
  const vendorId = safe(data.payee_id ?? data.id ?? data.ref);

  return (
    <>

      <div className="yx-vpCard mb-4">
        <div className="yx-vpHead">
          <div className="yx-vpLeft">
            <div className="yx-vpAvatar" title="Vendor">
              {initials(data.title)}
            </div>

            <div className="yx-vpTitleWrap">
              <div className="yx-vpKicker">Vendor overview</div>
              <div className="yx-vpName" title={title}>{title}</div>

              {/* <div className="yx-vpMeta">
                <span className="yx-vpPill" title="Vendor ID">
                  <i className="fa fa-id-badge" />
                  {vendorId}
                </span>
              </div> */}
            </div>
          </div>
        </div>

        <div className="yx-vpBody">
          <div className="yx-vpGrid">
            <InfoCell icon="fa-envelope" label="Email" value={data.email} />
            <InfoCell icon="fa-phone" label="Phone" value={data.phone_number} />
            <InfoCell icon="fa-location-dot" label="Address" value={data.address} />
            <InfoCell icon="fa-building" label="Type" value={data.type || data.category} />
          </div>

          <div className="yx-vpNotes">
            <div className="yx-vpNotesHead">
              <i className="fa fa-note-sticky" />
              Notes
            </div>
            <div className="yx-vpNotesBody">{safe(data.description)}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VendorProfile;
